import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";
import { getInitials } from "../../../utils/getInitials";

export default function CssfPdfUserInformation( { resumeData } ) {

    const { isAnonymous, isExperienceHidden } = extractResumeProperties( resumeData );
    const { user, experiences } = extractResumeDataDocumentSection( resumeData );

    const styles = StyleSheet.create( {
        section: {
            flexDirection: 'row',
            marginBottom: 0,
            fontSize: '10pt',
        },
        textStart: {
            fontFamily: "Verdana, sans-serif",
            fontSize: "9px",
            textAlign: 'start',
            margin: 0
        },
        leftColumn: {
            justifyContent: 'flex-start',
            width: '30%',
        },
        rightColumn: {
            width: '70%',
            marginLeft: 12,
        },
    } );

    return (
        <>
            <View style={ styles.section }>
                <View style={ styles.leftColumn }>
                    <Text style={ {
                        ...styles.textStart,
                        color: "#009999",
                        marginTop: 4,
                        textAlign: "right"
                    } } >
                        INFORMATION PERSONNELLE
                    </Text>
                </View>
                <View style={ [ styles.rightColumn, { width: "70%" } ] }>
                    <Text style={ {
                        ...styles.textStart,
                        fontSize: "13px",
                        color: "#3F3A38",
                    }  }>
                        { isAnonymous
                            ? getInitials( user.firstName ) + ' ' + getInitials( user.lastName, true )
                            : user.firstName + ' ' + user.lastName }
                    </Text>
                    { !isExperienceHidden && (
                        <Text style={  {
                            ...styles.textStart,
                            color: "#3F3A38",
                            marginTop: 8
                        } }>
                            { experiences?.[ 0 ]?.employer }
                        </Text>
                    ) }
                </View>
            </View>
        </>
    );
}
